export const API = {
  BASE_URL: "https://newstrial-api.bairuhatech.com/api/",
  // BASE_URL: "http://localhost:8073/api/",
  // GRAPHQL: "https://api2.suprabhaatham.com/graphql",
  // GRAPHQL: "http://localhost:8080/graphql",
  // APP_URL: "https://www.suprabhaatham.com/",
  // EDITOR_API_KEY: "a88vqf05b0e8l04vr9rgei6lnsno0j02twz9wml46yyltwi7",
  // WHATS_APP_LINK: "https://chat.whatsapp.com/Ebq27HufM0NHH37t6blQtO",

  CACHE_SERVER_1: "http://51.159.194.148/",
  CACHE_SERVER_2: "http://51.159.97.6/",
  CACHE_SERVER_3: "http://62.210.171.34/",
  CACHE_SERVER_4: "http://3.110.62.60/", //TEST

  // EPAPER_PDF: "http://localhost:3001/pdf/convert",
  // EPAPER_IMAGE: "http://localhost:3001/img/upload",
  EPAPER_PDF: "https://e-files.suprabhaatham.com/pdf/convert",
  EPAPER_IMAGE: "https://e-files.suprabhaatham.com/img/upload",
  // EPAPER_PDF: "https://news-trial-pdf-server.bairuhatech.com/pdf/convert",
  // EPAPER_IMAGE: "https://news-trial-pdf-server.bairuhatech.com/img/upload",

  // ---------endpoints----- --

  EPAPER_LIST: "filterEpaper", //POSTs
  EPAPER_ADD: "e-papers", // POST
  EPAPER_EDIT: "e-papers/", // PUT
  EPAPER_DELETE: "e-papers/", // DELETE
  EPAPER_PUBLISH: "e-papers", //PUT
  EPAPER_DETAILS: "e-papers/", //GET

  LOGIN: "userLogin",
  USERS: "users",
  CREATE_USER: "createUser",
  PUT_UPDATE_USER: "updateUser/",
  GET_USERS: "getusers",
  GET_USERSEARCH: "usersearch",
  DELETE_USER: "deleteUser/",
  GET_USERS_LIST: "filterUsers",

  UPLOAD_IMAGE_OR_PDF: "uploadImageorPdf",
  GET_SUBSCRIBTION: "subscriptions?populate=*",
};
